import { LogLevel } from '@azure/msal-browser'

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_MSAL_TENANT_ID}`,
    redirectUri: '/',
    postLogoutRedirectUri: '/login',
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
    secureCookies: process.env.NODE_ENV === 'production',
  },
  system: {
    iframeHashTimeout: 10000,
    tokenRenewalOffsetSeconds: 300,
    loggerOptions: {
      logLevel: LogLevel.Info,
    },
  },
}

export const loginRequest = {
  scopes: ['api://f052194b-083b-4532-b11f-1064377f939b/User.Read.All'],
}
